import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Title } from '@angular/platform-browser';

import { Operation } from '../../models/models';
import { HeaderService } from '../../services/header.service';
import { AuthGuard } from '../../services/auth/auth.guard';
import { SystemPointsLogService } from "../../services/system-points-log.service";

@Component({
  selector: 'app-operation-list',
  templateUrl: './operation-list.component.html'
})
export class OperationListComponent implements OnInit {
  operations: Operation[];
  operationsCount: number;
  showMoreBtn: boolean;
  activityCount: number;
  userName: string;
  userId: number;

  constructor(
    private title: Title,
    private translate: TranslateService,
    private headerService: HeaderService,
    private systemPointsLogService: SystemPointsLogService,
    private authGuard: AuthGuard,
    private route: ActivatedRoute) { }

  ngOnInit() {
    this.authGuard.authLoggedIn$.subscribe(user => {
      this.userId = user.id;
      this.translate.get('Pages.OperationList').subscribe((res: any) => {
        this.title.setTitle(res.Title);
        this.headerService.setPageTitle(false, 0, res.Title);
      });
      
      this.activityCount = this.route.snapshot.data.activityCount;
      this.operations = this.route.snapshot.data.operations;
      this.operationsCount = this.route.snapshot.data.operationsCount;
      this.defineShowMore();
    });
  }

  showMore() {
    this.systemPointsLogService.getAll(this.userId, this.operations.length, 5).subscribe((res: any) => {
      this.operations = this.operations.concat(res);
      this.defineShowMore();
    });
  }

  defineShowMore() {
    this.showMoreBtn = this.operationsCount > this.operations.length;
  }
}
